module.exports = __webpack_public_path__ + "img/samsung-redmi-note-11.8276e7c1.png";